'use client';

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import * as React from 'react';
import { display12HourValue, Period, setDateByType } from './time-picker-utils';

interface PeriodSelectorProps {
    period: Period;
    setPeriod?: (m: Period) => void;
    date?: Date | null;
    onDateChange?: (date: Date | undefined) => void;
    onRightFocus?: () => void;
    onLeftFocus?: () => void;
}

const TimePeriodSelect = React.forwardRef<
    HTMLButtonElement,
    PeriodSelectorProps
>(
    (
        { period, setPeriod, date, onDateChange, onLeftFocus, onRightFocus },
        ref
    ) => {
        const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
            if (e.key === 'ArrowRight') onRightFocus?.();
            if (e.key === 'ArrowLeft') onLeftFocus?.();
        };

        const handleValueChange = (value: Period) => {
            setPeriod?.(value);

            /**
             * trigger an update whenever the user switches between AM and PM;
             * otherwise user must manually change the hour each time
             */
            if (date) {
                const tempDate = new Date(date);
                const hours = display12HourValue(date.getHours());
                onDateChange?.(
                    setDateByType(
                        tempDate,
                        hours.toString(),
                        '12hours',
                        period === 'AM' ? 'PM' : 'AM'
                    )
                );
            }
        };

        return (
            <div className='flex h-10 items-center'>
                <Select
                    defaultValue={period}
                    onValueChange={(value: Period) => handleValueChange(value)}
                >
                    <SelectTrigger
                        ref={ref}
                        className='w-[65px] focus:bg-accent focus:text-accent-foreground'
                        onKeyDown={handleKeyDown}
                    >
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value='AM'>AM</SelectItem>
                        <SelectItem value='PM'>PM</SelectItem>
                    </SelectContent>
                </Select>
            </div>
        );
    }
);

TimePeriodSelect.displayName = 'TimePeriodSelect';
export default TimePeriodSelect;
